jQuery(document).ready(function () {
    const buttonCopy = jQuery('.copy-button');
    const shareCopy = jQuery('.share-copy');

    jQuery(buttonCopy).on('click', (e) => {
        e.preventDefault();
        copyIngredients();
    })

    jQuery(shareCopy).on('click', (e) => {
        e.preventDefault();
        copyCurrentUrl();
    })

    function copyIngredients() {
        const ingredients = jQuery('.intern-recipe__group-ingredients ul');
        let textToCopy = jQuery(ingredients).text();
        const el = document.createElement('textarea');
        el.value = textToCopy; 
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        showIngredientsTooltip();
    }
    
    function showIngredientsTooltip() {
        jQuery(".intern-recipe__tooltip").addClass("intern-recipe__tooltip--active");

        setTimeout(function(){
            jQuery(".intern-recipe__tooltip").removeClass("intern-recipe__tooltip--active");
        }, 1000);
    }

    function showURLTooltip() {
        jQuery(".social-share__tooltip").addClass("social-share__tooltip--active");

        setTimeout(function(){
            jQuery(".social-share__tooltip").removeClass("social-share__tooltip--active");
        }, 1000);
    }

    function copyCurrentUrl() {
        let textToCopy = window.location.href;
        const el = document.createElement('textarea');
        el.value = textToCopy;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        showURLTooltip();
    }
})